import loadable from 'react-loadable';
import LazyLoading from './lazy-loading';

export const EmailNum = loadable({
    loading: () => null,
    loader: () => import('../user/user.emailNum'),
});
export const Password = loadable({
    loading: () => null,
    loader: () => import('../user/user.password')
});
export const Forget = loadable({
    loading: () => null,
    loader: () => import('../user/user.forget')
});
export const SetPwd = loadable({
    loading: () => null,
    loader: () => import('../user/user.setPwd')
});
export const Update = loadable({
    loading: () => null,
    loader: () => import('../user/user.update')
});
export const NewPwd = loadable({
    loading: () => null,
    loader: () => import('../user/user.newPwd')
});
export const Profile = loadable({
    loading: () => null,
    loader: () => import('../user/user.profile')
});
export const Delete = loadable({
    loading: () => null,
    loader: () => import('../user/user.delete')
});
export const Age = loadable({
    loading: () => null,
    loader: () => import('../user/user.age')
});
export const Guardian = loadable({
    loading: () => null,
    loader: () => import('../user/user.guardian')
});
export const Agreement = loadable({
    loading: () => null,
    loader: () => import('../user/user.agreement')
});
export const Ifttt = loadable({
    loading: () => null,
    loader: () => import('../user/ifttt')
});
export const Connect = loadable({
    loading: () => null,
    loader: () => import('../connect/connect')
});
export const NoDriver = loadable({
    loading: () => null,
    loader: () => import('../connect/nodriver')
});
export const ConnectUnable = loadable({
    loading: () => null,
    loader: () => import('../connect/connect.error')
});
export const Upload = loadable({
    loading: () => null,
    loader: () => import('../upload/upload')
});
export const ConfirmSave = loadable({
    loading: () => null,
    loader: () => import('../confirm/save')
});
export const UpdaterAppRestart = loadable({
    loading: () => null,
    loader: () => import('../updater/app/restart')
});
export const UpdaterFirmware = loadable({
    loading: () => null,
    loader: () => import('../updater/firmware')
});
export const UpdaterFirmwareNotMatch = loadable({
    loading: () => null,
    loader: () => import('../updater/firmware/notmatch')
});
export const UpdaterFirmwareProgress = loadable({
    loading: () => null,
    loader: () => import('../updater/firmware/progress')
});
export const Example = loadable({
    loading: () => null,
    loader: () => import('../example')
});
export const Extensions = loadable({
    loading: () => null,
    loader: () => import('../extension')
});
export const Calibrate = loadable({
    loading: () => null,
    loader: () => import('../extension/calibrate')
});
export const Sprites = loadable({
    loading: () => null,
    loader: () => import('../sprites')
});
export const Loading = loadable({
    loading: () => null,
    loader: () => import('../editor/loading')
});
export const SaveAs = loadable({
    loading: () => null,
    loader: () => import('../editor/saveas')
});
export const WebSaveAs = loadable({
    loading: () => null,
    loader: () => import('../editor/saveas.web')
});
export const About = loadable({
    loading: LazyLoading,
    loader: () => import('../help/about')
});
export const Feedback = loadable({
    loading: LazyLoading,
    loader: () => import('../help/feedback')
});
export const ProjectsWeb = loadable({
    loading: () => null,
    loader: () => import('../projects/projects.web')
});

export const UserDelete = loadable({
    loading: () => null,
    loader: () => import('../user/user.delete')
});
export const ConfirmLogout = loadable({
    loading: () => null,
    loader: () => import('../confirm/logout')
});
export const ProjectDelete = loadable({
    loading: () => null,
    loader: () => import('../projects/project.delete')
});
export const UpdaterAppChecker = loadable({
    loading: () => null,
    loader: () => import('../updater/app/checker')
});
export const Share = loadable({
    loading: () => null,
    loader: () => import('../share')
});
export const ShareSuccess = loadable({
    loading: () => null,
    loader: () => import('../share/share.success')
});
export const CancelShare = loadable({
    loading: () => null,
    loader: () => import('../share/share.cancel')
});
export const ShareProjectTo = loadable({
    loading: () => null,
    loader: () => import('../help/share.project.to')
});